import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { splitter } from "../components/Listing";
export var getGlobalDictionaryTerm = function getGlobalDictionaryTerm(sitecoreContext, termKey) {
  if (!termKey || !sitecoreContext) {
    return;
  }
  var dictionary = sitecoreContext.globalDictionary && sitecoreContext.globalDictionary.items;
  if (!dictionary) {
    return;
  }
  var term = dictionary.find(function (termObj) {
    return termObj.key === termKey;
  });
  return term && term.value;
};
export var getMediaHost = function getMediaHost() {
  return process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '/';
};
export var getDomain = function getDomain() {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return '/';
};
export function pathJoin(parts) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var replace = new RegExp(separator + '{1,}', 'g');
  return parts.join(separator).replace(replace, separator);
}
export function get(obj, propPath, defaultValue) {
  return getPropertyByPath(obj, propPath, defaultValue);
}
export function getPropertyByPath(obj, propPath, defaultValue) {
  return propPath.split('.').reduce(function (o, p) {
    return o && o[p] || defaultValue;
  }, obj);
}
export var reduceHits = function reduceHits() {
  var hits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isShowFeatured = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _hits = _slicedToArray(hits, 1),
    first = _hits[0];
  return first && first.featured && isShowFeatured ? hits : hits.slice(0, -1);
};

// homebrew date formatting supporting English and Arabic to reduce size of JS bundle
export var getFormatedDate = function getFormatedDate(date, language) {
  var includeDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!language) {
    return getFormatedDateForEn(date);
  }
  var languageCode = language.toLocaleLowerCase();
  if (languageCode === 'en') {
    return getFormatedDateForEn(date, includeDay);
  } else if (languageCode === 'ar') {
    return getFormatedDateForAr(date, includeDay);
  }
  return getFormatedDateForEn(date);
};
var parseDate = function parseDate(date) {
  var isoDateRegEx = new RegExp('^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$');
  var d = new Date();
  if (!isNaN(Number(date.toString()))) {
    d = new Date(date);
  } else if (isoDateRegEx.test(date.toString())) {
    d = new Date(date.toString());
  } else {
    d = new Date(date + 'T00:00:00.000');
  }
  return d;
};
var getFormatedDateForEn = function getFormatedDateForEn(date) {
  var includeDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var d = parseDate(date);
  if (includeDay) {
    return "".concat(d.getDate(), " ").concat(months[d.getMonth()], " ").concat(d.getFullYear());
  } else {
    return "".concat(months[d.getMonth()], " ").concat(d.getFullYear());
  }
};
export var twoDigitsFormat = function twoDigitsFormat(num) {
  var str = num.toString();
  return str.length === 1 ? "0" + str : str;
};
export var monthList = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

// dd-month-yyyy Format
export var getFormatedDateForAnalytics = function getFormatedDateForAnalytics(date) {
  return "".concat(twoDigitsFormat(date.getDate()), "-").concat(monthList[date.getMonth()], "-").concat(date.getFullYear());
};
var getFormatedDateForAr = function getFormatedDateForAr(date) {
  var includeDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var months = ['يناير', 'فبراير', 'مارس', 'إبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  var days = ['اﻷحد', 'اﻷثنين', 'الثلاثاء', 'اﻷربعاء', 'الخميس', 'الجمعة', 'السبت'];
  var d = parseDate(date);
  if (includeDay) {
    return "".concat(days[d.getDay()], ", ").concat(d.getDate(), " ").concat(months[d.getMonth()], ", ").concat(d.getFullYear());
  } else {
    return "".concat(months[d.getMonth()], ", ").concat(d.getFullYear());
  }
};
export var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
export var getRecentSearches = function getRecentSearches() {
  if (!canUseDOM) {
    return [];
  }
  var localStorageValue = localStorage.getItem('recentSearches');
  if (localStorageValue != null) {
    return JSON.parse(localStorageValue);
  }
  return [];
};
export var saveRecentSearches = function saveRecentSearches(recentSearches) {
  if (!recentSearches || !canUseDOM) {
    return;
  }
  localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
};
export var isClient = function isClient() {
  return typeof window !== undefined;
};
export var isChina = function isChina() {
  if (canUseDOM) {
    var urlParams = new URLSearchParams(document.location.search);
    var isC = Boolean(urlParams.get('isChina') === 'true');
    return isC;
  } else {
    return false;
  }
};
export var getListingItemURL = function getListingItemURL(host, url, fullURL, isChina) {
  var generatedHost = host.split('?')[0];
  return generatedHost ? "".concat(generatedHost, "/").concat(url) : fullURL;
};
var getLocation = function getLocation(href) {
  var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7]
  };
};
export var getVideoItemURL = function getVideoItemURL() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isChina = arguments.length > 1 ? arguments[1] : undefined;
  var generatedHost = getLocation(url);
  // @ts-ignore
  return generatedHost && generatedHost.pathname ? generatedHost.pathname : url;
};
export var getListingLocation = function getListingLocation() {
  if (canUseDOM) {
    var _window$location = window.location,
      origin = _window$location.origin,
      pathname = _window$location.pathname;
    return pathname.slice(-1) == '/' ? "".concat(origin).concat(pathname.slice(0, -1)) : "".concat(origin).concat(pathname);
  }
  return '';
};
export var pick = function pick(obj, keys) {
  return keys.map(function (k) {
    return k in obj ? _defineProperty2({}, k, obj[k]) : {};
  }).reduce(function (res, o) {
    return Object.assign(res, o);
  }, {});
};
export var removeImageResolution = function removeImageResolution(src) {
  var queryStr = src.split('?')[1];
  var clearedQueryStr = queryStr ? queryStr.split('&').filter(function (item) {
    return item.indexOf('h=') != 0 && item.indexOf('w=') != 0;
  }).join('&') : '';
  return src.split('?')[0] + '?' + clearedQueryStr;
};
export var injectImageResolution = function injectImageResolution(src, width, height) {
  var imageSrc = removeImageResolution(src);
  return "".concat(imageSrc).concat(imageSrc.match(/\?/) ? '&' : '?', "cw=").concat(width, "&ch=").concat(height);
};
export var getDictionaryItem = function getDictionaryItem(dictionary, value) {
  if (dictionary) {
    var dictionaryItems = dictionary.dictionaryValues;
    var output = '';
    dictionaryItems.find(function (item) {
      if (item.key.jss.value.toLowerCase() === value.toLowerCase()) {
        if ('phrase' in item) {
          output = item.phrase.jss.value;
        }
        if ('image' in item) {
          output = item.image.jss.value;
        }
      }
    });
    return output;
  } else {
    return '';
  }
};
export var getDictionarySvg = function getDictionarySvg(dictionary, value) {
  if (dictionary) {
    var dictionaryItems = dictionary.dictionaryValues;
    var output = '';
    dictionaryItems.find(function (item) {
      if (item.key.jss.value.toLowerCase() === value.toLowerCase()) {
        if ('svg' in item) {
          output = item.svg.jss.value;
        }
      }
    });
    return output;
  } else {
    return '';
  }
};
export var generatrURLFromTags = function generatrURLFromTags(tags) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tags';
  var urlTags = "?".concat(label, "=");
  var tagsNamesArray = getTagsNames(tags);
  return tagsNamesArray.length ? urlTags + encodeURIComponent(tagsNamesArray.join(splitter)) : '';
};
export var getTagsNames = function getTagsNames(tags, prefix) {
  var tagsArray,
    result = [];
  if (tags.length) {
    tagsArray = tags.map(function (item) {
      var tag = get(item, 'title.jss.value') || get(item, 'name') || '';
      return prefix ? prefix + tag : tag;
    });
    result = tagsArray.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });
  }
  return result;
};
export var getTags = function getTags(tags, propValue) {
  var tagsValues = get(tags, 'values');
  if (tagsValues) {
    var tagsArray = [];
    tagsArray = tagsValues.map(function (item) {
      var tag = get(item, 'title.jss.value') || get(item, 'name');
      return propValue ? propValue + tag : 'tags:' + tag;
    });
    return tagsArray;
  } else {
    return [];
  }
};
export var getURLSearchByName = function getURLSearchByName(name) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
export var hexToRgb = function hexToRgb(hex) {
  var valuesOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var color = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) {
    return '#' + r + r + g + g + b + b;
  }).substring(1).match(/.{2}/g).map(function (x) {
    return parseInt(x, 16);
  });
  return valuesOnly ? color.join(',') : "rgb(".concat(color.join(','), ")");
};
export var getFeaturedItemAndList = function getFeaturedItemAndList() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var featuredList = list.filter(function (item) {
    return item.featured || item.item && item.item.featured;
  });
  if (featuredList.length > 1) {
    featuredList.sort(function (a, b) {
      return a.priority - b.priority;
    });
  }
  var featuredIndex = featuredList.length ? list.findIndex(function (item) {
    return item.objectID === featuredList[0].objectID;
  }) : -1;
  return {
    list: featuredIndex !== -1 ? [].concat(_toConsumableArray(list.slice(0, featuredIndex)), _toConsumableArray(list.slice(featuredIndex + 1))) : list,
    featured: list[featuredIndex]
  };
};
export var mobileCheck = function mobileCheck() {
  var check = false;
  (function (a) {
    if (typeof window !== 'undefined' && /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
export var hideContainerByChild = function hideContainerByChild() {
  var childClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var parentClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var child = document.querySelector(childClass);
  // @ts-ignore
  var parent = child.closest(parentClass);
  // @ts-ignore
  parent.style.display = 'none';
};
export var replaceWhitespace = function replaceWhitespace() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return val && val.replace(/\s/g, '-');
};
var blackColoredThemes = ['#97999B', '#C8C9C7', '#00D3B4', '#FCAA28', '#D6D2C4', '#FFFFFF'];
export var getColorClassByTheme = function getColorClassByTheme(themeColor) {
  if (blackColoredThemes.includes(themeColor)) {
    return 'black-colored-theme';
  } else {
    return 'white-colored-theme';
  }
};
export var getColorByTheme = function getColorByTheme(themeColor) {
  if (blackColoredThemes.includes(themeColor)) {
    return '#000';
  } else {
    return '#fff';
  }
};
export var getPageThemeColors = function getPageThemeColors() {
  var isVDsite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  if (isVDsite) {
    return {
      primary: '#035E88',
      primary_active: '#004565'
    };
  }
  return {
    primary: '#005F66',
    primary_active: '#115E67'
  };
};
export var replaceUrlPluses = function replaceUrlPluses() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isSwitch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (str) {
    var arr = str.split('');
    var plusIndexes = [];
    arr.forEach(function (item, index) {
      if (item === '+') {
        plusIndexes.push(index);
      }
    });
    if (isSwitch) {
      if (str.includes('+') && str.includes('%20')) {
        return str.replace(/\%20/g, ' ');
      } else {
        var newStr = str;
        var newStrArr = str.split('');
        plusIndexes.forEach(function (el, i) {
          // 5++days -> 5+ days
          if (el + 1 === plusIndexes[i + 1]) {
            newStrArr[el + 1] = ' ';
            newStr = newStrArr.join('');
          } else if (plusIndexes.length === 1 && newStrArr[el + 1] === ' ') {
            return str;
          }
          // 5%2B+days
          else if (plusIndexes.length === 1 && str.includes('%2B') && str.includes('+')) {
            newStr = str;
            newStr = newStr.replace(/\+/g, ' ');
            newStr = newStr.replace(/\%2B/g, '+');
          }
          //business+events;,leisure+events;art+&+events
          else {
            newStrArr[el] = ' ';
            newStr = newStrArr.join('');
          }
        });
        return newStr;
      }
    } else {
      return str.replace(/\+/g, ' ');
    }
  }
};
export var NAV_LINKS = {
  search: 'Search',
  eventCalendar: 'Event calendar',
  topPicks: 'Top picks',
  venuesShortlist: 'Venues Shortlist',
  interactiveMap: 'Interactive map'
};
export var isNavLinkRendered = function isNavLinkRendered(menulinks, key) {
  var activeItem = menulinks.filter(function (link) {
    return (link.name && link.name.toLowerCase()) === (key && key.toLowerCase());
  });
  if (activeItem.length > 0) {
    return activeItem[0];
  } else {
    return null;
  }
};
export var celsiusToFahrenheit = function celsiusToFahrenheit(tC) {
  return +(tC * 1.8 + 32).toFixed(1);
};
export var getLimitedText = function getLimitedText(field) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (typeof field === 'string') {
    return field.length <= limit ? field : field.substring(0, limit).concat(end);
  }
  return field.value.length <= limit ? field : _objectSpread(_objectSpread({}, field), {}, {
    value: field.value.substring(0, limit).concat(end)
  });
};
export var fileToBase64 = function fileToBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      return resolve(reader.result.split(",")[1]);
    };
    reader.onerror = function (error) {
      return reject(error);
    };
  });
};
export var getSizeFromBase64 = function getSizeFromBase64(base64str) {
  var paddingCount = base64str.endsWith("==") ? 2 : base64str.endsWith("=") ? 1 : 0;
  return Math.floor(base64str.length * 3 / 4) - paddingCount;
};